import { useContext } from 'react';
import { featureFlagsContext } from '../providers/FeatureFlagsProvider';

export const useIsApplePayEnabled = () => {
  const { isEnableApplePay, loading } = useContext(featureFlagsContext);

  return !loading && isEnableApplePay;
};
